import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Footer = styled.footer`
	display: flex;
	flex-direction: column;
`

export const FooterWrapper = styled.div`
	background: #f8f8f8;
	padding: 30px 10px;
	display: flex;
	justify-content: center;
	flex-direction: column;
`

export const FooterContainer = styled.div`
	max-width: 1440px;
	width: 100%;
	display: flex;
	justify-content: space-between;
	margin: 0 auto;
	gap: 20px;

	@media(max-width: 1024px) {
	gap:5px;
	}

	@media(max-width: 768px) {
	flex-wrap: wrap;
	justify-content: center;
	}
	
`

export const SubFooterContainer = styled(FooterContainer)`
	@media(max-width: 1024px) {
	flex-wrap: wrap;
	justify-content: center;
	}

`
export const FooterLogoContainer = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 14px;
	text-align: center;
	color: #555;
	max-width: 100px;

	display: flex;
	flex-direction: column;
	
	align-items: center;
	gap: 17px;

	@media(max-width: 530px) {
	  font-size: 16px;
	  max-width: 215px;
	  flex-direction: row;
    span {

	  position: relative;
	&::before {
		content: '';
		position: absolute;
		left: -7px;
		top: 0;
		bottom: 0;
		width: 2px;
		background: #555;
	}
}
	}
`
export const LeftColumn = styled.div`
	display: flex;
	align-items: center;
	gap: 50px;

	@media(max-width: 1024px) {
	gap: 30px;
	}

	@media(max-width: 768px) {
	gap: 85px;
	}

	@media (max-width: 530px) {
    flex-direction: column;
    width: 100%;
	gap: 20px;
    align-items: flex-start;
  }
	
`
export const FooterLogo = styled.img`
	max-width: 75px;

	@media(max-width: 530px) {
	max-width: 62px;
	}
`
export const FooterMenu = styled.div`
	display: flex;
	gap: 60px;

	@media(max-width: 1024px) {
	gap: 17px;
	}

	@media(max-width: 768px) {
	  gap: 95px;
	  justify-content: start;
	  
	}
`
export const RequestMenuColumn = styled(FooterMenu)`
	@media(max-width: 768px) {
	  gap: 0;
	  flex-direction: column;
	}
`

export const FooterMenuColumn = styled.div``
export const MenuTitle = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #484848;
	margin-bottom: 10px;
	margin-left: -12px;

	@media(max-width: 1024px){
	 font-size: 13px;
	}
	 	@media(max-width: 768px){
	 font-size: 16px;
	}
`

export const Menulist = styled.div`
	position: relative;
	&::before {
		content: '';
		position: absolute;
		left: -7px;
		top: 0;
		bottom: 0;
		width: 1px;
		background: #018d47;
	}
`


export const FooterTooltip = styled.div`
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #62656c;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 10px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  z-index: 10;
  pointer-events: none;
`

export const MenuItem = styled.div<{ $isDev?: boolean }>`
  font-family: 'e-Ukraine', sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 190%;
  color: #777;
  cursor: ${props => props.$isDev ? 'default' : 'pointer'};
  transition: color 0.3s ease;
  position: relative;

  &:hover {
    color: #018d47;
  }

  &:hover ${FooterTooltip} {
    opacity: ${props => props.$isDev ? '1' : '0'};
    visibility: ${props => props.$isDev ? 'visible' : 'hidden'};
  }
`

export const RightColumn = styled.div`
	display: flex;
	gap: 25px;
	padding-right: 30px;
	align-items: start;

	@media(max-width: 1024px) {
	gap: 5px;
	}

	@media(max-width: 768px) {
	 margin-top: 50px;
	 	gap: 25px;
	}
`

export const HelpColumn = styled.div``
export const TechnicalSupportColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`
export const TechnicalSupportLogo = styled.div`
	display: flex;
	align-items: center;
	gap: 35px;

	@media(max-width: 768px) {
	  gap: 10px;
	}
`
export const TechnicalSupportTitle = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 300;
	font-size: 11px;
	text-transform: uppercase;
	color: #555;
`
export const CUITLogo = styled.img`
 max-width: 50px;
`
export const Text = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 200;
	font-size: 12px;
	letter-spacing: 0.02em;
	text-transform: uppercase;
	color: #555;

	@media(max-width: 530px) {
	     font-size: 10px;
	}
`
export const TechnicalSupportText = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 11px;
	line-height: 137%;
	color: #555;
	max-width: 200px;

	@media(max-width: 768px) {
	  display: flex;
	  align-items: center;
	  gap: 3px;
	  max-width: 255px
	 }
`
export const TechnicalSocials = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
`
export const SocialsIcon = styled.img``
export const HelpWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	max-width: 300px;
	padding: 13px 15px 10px 15px;
	background: #f4f4f4;
	border-radius: 20px;
	box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
	overflow: visible;

	&::after {
		content: '';
		position: absolute;
		transform: rotate(-38deg);
		right: 0px;
		bottom: -7px;
		width: 22px;
		height: 18px;
		background: #f4f4f4;
		clip-path: polygon(50% 100%, 0 0, 100% 0);
		filter: drop-shadow(0 6px 6px rgba(0, 0, 0, 0.2));
	}

	@media(max-width: 1024px) {
	max-width: 220px;
	}
	@media(max-width: 768px) {
	max-width: 350px;
	}
	
`
export const HelpText = styled.div`
	font-family: 'e-Ukraine-Head', sans-serif;
	font-weight: 400;
	font-size: 13px;
	color: #555;
	margin-bottom: 5px;
`
export const FooterButton = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 11px;
	color: #fff;
	border-radius: 100px;
	cursor: pointer;
	padding: 5px 10px;
	background-color: #018d47;
	border-radius: 100px 100px 0 100px;
	max-width: 105px;
	display: flex;
	justify-content: center;
	margin-left: auto;
`

export const SubFooter = styled.div`
	background: #62656c;
	padding: 20px 10px;
	
`

export const SubFooterText = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 300;
	font-size: 15px;
	text-align: center;
	color: #fff;

	span {
		text-transform: uppercase;
	}

		@media(max-width: 1024px) {
    font-size: 13px
	}
	

	@media(max-width: 425px) {
	 font-size: 12px;
	}
`
export const SubFooterLink = styled(Link)`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 500;
	font-size: 13px;
	text-decoration: underline;
	text-decoration-skip-ink: none;
	color: #fff;
	cursor: pointer;
`


export const MobileAccordion = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const AccordionItem = styled.div`
  border-bottom: 1px solid #d9d9d9;
`



export const AccordionArrow = styled.span<{ $isOpen: boolean }>`
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: ${props => props.$isOpen ? 'none' : '6px solid #484848'};
  border-bottom: ${props => props.$isOpen ? '6px solid #484848' : 'none'};
  flex-shrink: 0;
`

export const AccordionBody = styled.div<{ $isOpen: boolean }>`
  overflow: hidden;
  max-height: ${props => props.$isOpen ? '200px' : '0'};
  transition: max-height 0.3s ease;
`


export const AccordionSubItem = styled.div<{ $isDev?: boolean }>`
  font-family: 'e-Ukraine', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #777;
  padding: 8px 0 8px 16px;
  cursor: ${props => props.$isDev ? 'default' : 'pointer'};
  transition: color 0.3s ease;
  position: relative;

  &:hover {
    color: #018d47;
  }
`

export const AccordionHeader = styled.div<{ $active?: boolean; $isDev?: boolean }>`
  font-family: 'e-Ukraine', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: ${props => props.$active ? '#018d47' : '#484848'};
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: ${props => props.$isDev ? 'default' : 'pointer'};
  transition: color 0.3s ease;
  position: relative;

  &:hover {
    color:#018d47;
  }
`

export const DevTooltip = styled.span`
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  background: #62656c;
  color: #fff;
  font-size: 10px;
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;

  ${AccordionHeader}:hover & {
    opacity: 1;
  }
`